// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

html {
  overflow-x: hidden;
  max-width: 100vw;
  /* Disables the browser's native pull-to-refresh/rubber-band gesture (the
     "drag down and everything shifts, revealing white space" effect on
     mobile Safari/Chrome). We show our own in-page loading states instead
     of relying on any drag-to-refresh interaction. */
  overscroll-behavior-y: none;
}

body {
  /* clip prevents horizontal scroll just like hidden, but does NOT
     create a scroll container — so position:sticky on descendants
     works correctly relative to the viewport. */
  overflow-x: clip;
  max-width: 100vw;
  overscroll-behavior-y: none;
}

/* An installed app should feel like one: taps should not flash a browser
   highlight and accidental long-presses should not select navigation chrome.
   Text fields and page content remain selectable.
   Both selectors, because this is true of any app launched from the home
   screen -- Capacitor's WebView (.is-native-app) and an installed PWA
   (html.m-installed) are the same finger on the same chrome. */
.is-native-app button,
.is-native-app [role="button"],
.is-native-app nav a,
html.m-installed button,
html.m-installed [role="button"],
html.m-installed nav a {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
  touch-action: manipulation;
}

/* Browser autofill (address/phone/payment data) forces its own light
   background + dark text via a UA style that ignores our theme --
   on dark mode this shows up as random inputs flashing white. Force
   it back to the app's actual input colors in both themes. */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-text-fill-color: var(--text-primary);
  box-shadow: 0 0 0 1000px var(--bg-secondary) inset;
  caret-color: var(--text-primary);
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

body {
  margin: 0;
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* The page canvas is painted by .app-shell, but body itself was left
     transparent -- so anywhere the shell doesn't reach (short pages, overscroll
     gutters, the area behind a fixed bottom nav) fell through to the browser's
     default white, which is glaring in dark mode. Paint it explicitly. */
  background: var(--color-page);
  color: var(--color-text-primary);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Accessibility: Respect user's motion preference
   Disable animations for users who prefer reduced motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* The FOUT guard that used to live here declared a second 'Inter' face
   resolving to local('Arial'). It carried no font-weight descriptor, so it
   matched weight 400 -- and because this stylesheet is bundled and therefore
   parsed after the inline @font-face rules in index.html, it could win the
   match and render body text in Arial while headings used the real font.
   Self-hosted Inter is preloaded from the same origin, so there is no FOUT
   window left to guard against and no reason to keep a decoy face. */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE;;cAEY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;qDAGmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE;;gDAE8C;EAC9C,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;;;;+DAK+D;AAC/D;;;;;;EAME,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;;6DAG6D;AAC7D;;;;;EAKE,4CAA4C;EAE5C,kDAAkD;EAClD,gCAAgC;EAChC,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;EAClC;;;yEAGuE;EACvE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE;aACW;AACb;;AAEA;2DAC2D;AAC3D;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA;;;;;;qEAMqE","sourcesContent":[":root {\n  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n}\n\nhtml {\n  overflow-x: hidden;\n  max-width: 100vw;\n  /* Disables the browser's native pull-to-refresh/rubber-band gesture (the\n     \"drag down and everything shifts, revealing white space\" effect on\n     mobile Safari/Chrome). We show our own in-page loading states instead\n     of relying on any drag-to-refresh interaction. */\n  overscroll-behavior-y: none;\n}\n\nbody {\n  /* clip prevents horizontal scroll just like hidden, but does NOT\n     create a scroll container — so position:sticky on descendants\n     works correctly relative to the viewport. */\n  overflow-x: clip;\n  max-width: 100vw;\n  overscroll-behavior-y: none;\n}\n\n/* An installed app should feel like one: taps should not flash a browser\n   highlight and accidental long-presses should not select navigation chrome.\n   Text fields and page content remain selectable.\n   Both selectors, because this is true of any app launched from the home\n   screen -- Capacitor's WebView (.is-native-app) and an installed PWA\n   (html.m-installed) are the same finger on the same chrome. */\n.is-native-app button,\n.is-native-app [role=\"button\"],\n.is-native-app nav a,\nhtml.m-installed button,\nhtml.m-installed [role=\"button\"],\nhtml.m-installed nav a {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  user-select: none;\n  touch-action: manipulation;\n}\n\n/* Browser autofill (address/phone/payment data) forces its own light\n   background + dark text via a UA style that ignores our theme --\n   on dark mode this shows up as random inputs flashing white. Force\n   it back to the app's actual input colors in both themes. */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\nselect:-webkit-autofill {\n  -webkit-text-fill-color: var(--text-primary);\n  -webkit-box-shadow: 0 0 0 1000px var(--bg-secondary) inset;\n  box-shadow: 0 0 0 1000px var(--bg-secondary) inset;\n  caret-color: var(--text-primary);\n  transition: background-color 5000s ease-in-out 0s;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--font-sans);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* The page canvas is painted by .app-shell, but body itself was left\n     transparent -- so anywhere the shell doesn't reach (short pages, overscroll\n     gutters, the area behind a fixed bottom nav) fell through to the browser's\n     default white, which is glaring in dark mode. Paint it explicitly. */\n  background: var(--color-page);\n  color: var(--color-text-primary);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Accessibility: Respect user's motion preference\n   Disable animations for users who prefer reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n/* The FOUT guard that used to live here declared a second 'Inter' face\n   resolving to local('Arial'). It carried no font-weight descriptor, so it\n   matched weight 400 -- and because this stylesheet is bundled and therefore\n   parsed after the inline @font-face rules in index.html, it could win the\n   match and render body text in Arial while headings used the real font.\n   Self-hosted Inter is preloaded from the same origin, so there is no FOUT\n   window left to guard against and no reason to keep a decoy face. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
